<template>
  <div>
    <!-- File Upload Section -->
    <input type="file" @change="handleFileUpload" />
    <button @click="uploadFile">Upload</button>

    <!-- Read and Import Buttons -->
    <button @click="readData" :disabled="!fileUploaded">Read</button>
    <button @click="importData" :disabled="!dataRead">Import</button>

    <!-- Download Results Button -->
    <a v-if="resultsAvailable" :href="resultsUrl" download>Download Results</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      fileUploaded: false,
      dataRead: false,
      resultsAvailable: false,
      resultsUrl: ''
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileUploaded = true;
    },
    async uploadFile() {
      if (!this.file) {
        alert('Please select a file first.');
        return;
      }
      
      const formData = new FormData();
      formData.append('file', this.file);

      try {
        const response = await fetch('http://localhost:3000/upload', {
          method: 'POST',
          body: formData
        });
        await response.json();
        this.dataRead = true; // Enable the Read button after successful upload
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    },
    async readData() {
      try {
        const response = await fetch('http://localhost:3000/read');
        await response.json();
        this.dataRead = true; // Enable the Import button after reading data
      } catch (error) {
        console.error('Error reading data:', error);
      }
    },
    async importData() {
      try {
        const response = await fetch('http://localhost:3000/import');
        await response.json();
        this.resultsAvailable = true;
        this.resultsUrl = 'http://localhost:3000/results';
      } catch (error) {
        console.error('Error importing data:', error);
      }
    }
  }
}
</script>
